module.exports = __webpack_public_path__ + "media/images/caregiver/caregiver_avatar_05-bbc5a1caacf9227192e9ae67b6ff2a2f.png";